import { css } from 'styled-components';

export const applyShadow = () => {
    return css`
        box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1),
            0px 4px 6px rgba(48, 65, 74, 0.06);
    `;
};
